module.exports = __webpack_public_path__ + "assets/img/one.bb05cd49.png";